import filter from 'lodash/filter';
import head from 'lodash/head';
import clone from 'lodash/clone';
import size from 'lodash/size';
import split from 'lodash/split';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import last from 'lodash/last';
import compact from 'lodash/compact';
import findLastIndex from 'lodash/findLastIndex';
import isEmpty from 'lodash/isEmpty';
import sumBy from 'lodash/sumBy';
import sortBy from 'lodash/sortBy';
import chunk from 'lodash/chunk';
import templateUrl from './trip-planner-main.html';

export const tripPlannerMainComponent = {
    bindings: {
        privateProvidersDetails: '<',
        directionDetails: '<',
        advanceOptionsDetails: '<',
        contactInfo: '<'
    },

    templateUrl,

    controller: class TripPlannerMainComponent {
        constructor($timeout, $state, $filter, $anchorScroll, $window, TripPlannerService, DateService, GoogleMapService, GoogleAnalytics, Constants) {
            'ngInject';

            this.tripPlannerService = TripPlannerService;
            this.dateService = DateService;
            this.googleMapService = GoogleMapService;
            this.$timeout = $timeout;
            this.$state = $state;
            this.$filter = $filter;
            this.googleAnalytics = GoogleAnalytics;
            this.$window = $window;
            this.$anchorScroll = $anchorScroll;
            this.Constants = Constants;
        }

        $onInit() {
            this.viewDetails = false;
            this.changeSearch = false;
            this.departAt = false;
            this.showDepartOption = false;
            this.mobileSearchOption = false;
            this.mobileFilterOption = false;
            this.mobileDepartOption = false;
            this.mobileMapViewOption = false;
            this.mobileHelpViewOption =false;
            this.isPrintOptionsVisible = false;
            this.isPrintSectionVisible = false;
            this.isPrintWithMap = true;
            this.showEditSearchLoader = true;
            this.showMapLoader = false;
            this.privateTravelTime = '0';
            this.privateTravelTimeUnit = 'Sec';
            this.encodedPrivateRoutePolyline = "";
            this.selectedServiceType = head(filter(this.privateProvidersDetails.serviceTypeList, ['name', 'Private Transportation']));

            this.privateProviders = [];
            this.paratransitProviders = [];
            this.volunteerProviders = [];

            this.primaryContactNumber = head(this.contactInfo.phone);

            this._updateProvidersList(this.privateProvidersDetails.providers);

            this.providersList = this._getSelectedProvidersList();

            this.noResultFound = this.privateProviders.count > 0 ? false : true;
            this.viewSelectedProviderDetails = {};
            this.publicRoutes = [];
            this.selectedPublicRoute;
            this.directionDetails = this.tripPlannerService.getdirectionDetailsObject(this.directionDetails);
            this.distance;

            this.selectedDepartTime = {
                range: {
                    startTime: {
                        title: '',
                        showWhiteClockImage: true,
                        selectedTime: new Date()
                    }
                }
            };

            this.departDateDetails = {
                disablePreviousDates: true,
                selectedDate: new Date(),
                showWhiteClockImage: true,
            };
            this.countyName = this._getCountyName();
            this.specificRequirementOptions = this.tripPlannerService.getSpecificRequirementsOptionsObject();
            this.directionDetails.departAt = this._getDepartAtDate();

            this.sortByList = this.tripPlannerService.getTripPlanningSortByOptions("byCost");
            this.selectedSortByOption = head(this.sortByList).id;
            this.privateProviders.count > 0 ? this._sortList() : true;

            this.addSearchedCountyInGoogleAnalytics();
            this._addGoogleAnalytics();
            this._updateCountyLevelSearchInGoogleAnalytics();

            this.radius = 0;
            this.maxDistance = 0;
            this.originBusStationDetails = '';
            this.destinationBusStationDetails = '';
            this.mapElement = document.getElementById('map-for-near-by');
            this.googleMapRouteDelayInMiliSeconds = 2000;
        }

        //************************** PUBLIC METHODS **********************************************/
        hideShowLoader(showLoader) {
            this.showEditSearchLoader = showLoader;
        }

        onMobileSearchOptionChange() {
            this.mobileSearchOption = !this.mobileSearchOption;
        }

        onChangeSearch() {
            this.$anchorScroll(() => $location.hash());
            this.changeSearch = !this.changeSearch;
        }

        onChangeFilterOption() {
            this.mobileFilterOption = !this.mobileFilterOption;
        }

        onChangeDepartAtOption() {
            this.mobileDepartOption = !this.mobileDepartOption;
        }

        openMobileMapView(selectedProviderId) {
            this.onSelectProvider(selectedProviderId);
            this.mobileMapViewOption = !this.mobileMapViewOption;
        }

        onSelectProvider(id) {
            this.providersList.filtered.map(provider => provider.isSelected = provider.id === id ? true : false);
            this.providersList.others.map(provider => provider.isSelected = provider.id === id ? true : false);
        }

        onSelectRoute(id) {
            this.publicRoutes = this.publicRoutes.map((route, index) => {
                route.isSelected = index === id ? true : false
                return route;
            });
            this.selectedPublicRoute = head(filter(this.publicRoutes, route => route.isSelected));
            this._getPublicRouteDetailsObject(this.selectedPublicRoute);
        }

        onChangeServiceType(id) {
            this.showMapLoader = true;
            this.mobileFilterOption = false;
            this.selectedServiceType = head(filter(this.privateProvidersDetails.serviceTypeList, ['id', id]));
            this.providersList = this._getSelectedProvidersList();
            this.noResultFound = this.providersList.count > 0 ? false : true;
            this._getDefaultSelectedProvider();
            this._updateDirectionDetails();
            this._updateSortByList();
            this.addServiceTypeDetailsInGoogleAnalytics('serviceRequestType');
            this._updateCountyLevelSearchInGoogleAnalytics();
            this._resetAllFlags();
        }

        getPublicProviderDetailsWithRoutes(routesDetailsObject) {
            if (routesDetailsObject && routesDetailsObject.routes) {
                this._setPublicProviderRouteDetails(routesDetailsObject)
                    // .then(details => this._getBreakJourneyRoutesIfPublicRoutesNotAvailable(details))
                    .catch(err => {
                        this._hideMapLoader();
                        this._noResultFound();
                    });
            } else {
                this._hideMapLoader();
                this._noResultFound();
            }
        }

        selectRouteMobileView(id) {
            this.selectRoute(id);
            this.mobileMapViewOption = !this.mobileMapViewOption;
        }

        getPrivateTravelDirectionDetails({ duration, distance: { text: totalDistance }, encodedPolyline }) {
            this.$timeout(() => {
                const durationText = split(duration.text, ' ');
                this.distance = totalDistance;
                this.privateTravelTime = duration.text;
                this.privateTravelTimeUnit = '';
                this.encodedPrivateRoutePolyline = encodedPolyline;
            });
        }

        showPrintOptions() {
            this.isPrintOptionsVisible = !this.isPrintOptionsVisible;
        }

        printTripDetails(optionId) {
            this.showPrintOptions();
            this._visiblePrintSection();
            this.isPrintWithMap = optionId === 0 ? true : false;
        }

        onCancelPrintOption() {
            this._visiblePrintSection();
        }

        onChangeSortBy(id) {
            this.selectedSortByOption = id;
            this._sortList();
        }

        onChangeDateTime() {
            this.selectedServiceType.name === "Public Transit" ? this._updateDirectionDetails() : this._getPrivateProvidersDetails();
        }

        getTotalProvidersCount(type) {
            switch (type) {
                case 'Private Transportation':
                    return this.privateProviders.count;
                case 'Paratransit':
                    return this.paratransitProviders.count;
                case 'Volunteer':
                    return this.volunteerProviders.count;
            }
        }

        onMobileHelpViewOptionChange() {
            this.mobileHelpViewOption = !this.mobileHelpViewOption;
        }

        /*---------------- google Analytics details ------------*/
        addServiceTypeDetailsInGoogleAnalytics(eventName = '', countyName = '') {
            const { name: label, id: value } = this.selectedServiceType;
            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action${countyName}`,
                eventLabel: label,
                eventValue: value
            };
            this.googleAnalytics.event(eventName, attributes);
        }

        addSpecificRequirementDetailsInGoogleAnalytics(eventName = '', countyName = '') {
            const selectedSpecificRequirement = head(filter(this.specificRequirementOptions, { name: this.advanceOptionsDetails.requirements }));
            if(selectedSpecificRequirement) {
                const {label, value} = selectedSpecificRequirement;
                const attributes = {
                    eventCategory: `${eventName}Category`,
                    eventAction: `${eventName}Action${countyName}`,
                    eventLabel: label,
                    eventValue: value
                };
                this.googleAnalytics.event(eventName, attributes);
            }
        }

        addMedicaidMemberDetailsInGoogleAnalytics(eventName = '', countyName = '') {
            const label = this.advanceOptionsDetails.isMedicaid ? 'medicaid member' : 'non medicaid member';
            const value = this.advanceOptionsDetails.isMedicaid ? 1 : 0;
            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action${countyName}`,
                eventLabel: label,
                eventValue: value
            };
            this.googleAnalytics.event(eventName, attributes);
        }

        addVeteranDetailsInGoogleAnalytics(eventName = '', countyName = '') {
            const label = this.advanceOptionsDetails.isVeteran ? 'veteran member' : 'non veteran member';
            const value = this.advanceOptionsDetails.isVeteran ? 1 : 0;
            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action${countyName}`,
                eventLabel: label,
                eventValue: value
            };
            this.googleAnalytics.event(eventName, attributes);
        }

        addSearchedCountyInGoogleAnalytics() {
            const eventName = "countySearch";
            const county = last(JSON.parse(this.advanceOptionsDetails.originServiceAreas));
            const attributes = {
                route: this.$window.location.href,
                eventCategory: "originCountySearchCategory",
                eventAction: "originCountySearch",
                eventLabel: county.placeShortName,
                eventNonInteraction: false
            };
            this.googleAnalytics.event(eventName, attributes);
        }

        addMedicaidTransportationDetailsInGoogleAnalytics() {
			const eventName = 'medicaidTransportationLink';

            const attributes = {
                eventCategory: `${eventName}Category`,
                eventAction: `${eventName}Action`,
                eventLabel: 'Medicaid transport link',
                eventNonInteraction: false
            };
            this.googleAnalytics.event(eventName, attributes);
		}

        //************************** PRIVATE METHODS **********************************************/

        _addGoogleAnalytics(countyName = '') {
            this.addServiceTypeDetailsInGoogleAnalytics('serviceRequestType', countyName);
            this.addSpecificRequirementDetailsInGoogleAnalytics('specificRequirement', countyName);
            this.addMedicaidMemberDetailsInGoogleAnalytics('medicaidMember', countyName);
            this.addVeteranDetailsInGoogleAnalytics('veteranMember', countyName);
        }

        _updateCountyLevelSearchInGoogleAnalytics() {
            if (this._isSearchCountyRegisteredInGoogleAnalytics()) {
                this._addGoogleAnalytics(this.countyName);
            }
        }

        _hideMapLoader() {
            this.$timeout(_ => this.showMapLoader = false);
        }

        _noResultFound() {
            this.noResultFound = true;
        }

        _getDefaultSelectedProvider() {
            let provider = head(this.providersList.filtered);
            if (provider) {
                provider = size(provider) === 0 ? head(this.providersList.others) : provider;
                this.onSelectProvider(provider.id);
            }
        }

        _getSelectedProvidersList() {
            const { name } = this.selectedServiceType;

            switch (name) {
                case 'Paratransit':
                    return this.paratransitProviders;
                case 'Volunteer':
                    return this.volunteerProviders;
                default:
                    return this.privateProviders;
            }
        }

        _getTime(time) {
            const isMinutesZero = new Date(time).getMinutes() === 0 ? true : false;
            return isMinutesZero ? this.$filter('date')(time, 'h a') : this.$filter('date')(time, 'h:mm a')
        }

        _onChangeMobileDateTime({ selectedDate, selectedTime }) {
            this.mobileDepartOption = false;
            this.departDateDetails.selectedDate = selectedDate;
            this.selectedDepartTime.range.startTime.selectedTime = selectedTime;
            this.onChangeDateTime();
        }

        _getDepartAtDate() {
            return this.departDateDetails.selectedDate ? this.dateService.parseDateFromServerDate(this._resetDateWithTime()) : new Date();
        }

        _resetDateWithTime() {
            return new Date(this.dateService.resetDateTimeWithOtherTime(this.departDateDetails.selectedDate, this.selectedDepartTime.range.startTime.selectedTime));
        }

        _sortList() {
            if (this.selectedSortByOption) {
                this.selectedServiceType.name === 'Public Transit' ? this._sortByTime() : this._sortByCost();
            }
        }

        _sortByCost() {
            let order = this.selectedSortByOption === 1 ? 'asc' : 'desc';
            this.providersList.filtered = clone(orderBy(this.providersList.filtered, [details => details.costing.value], [order]));
            this.providersList.others = clone(orderBy(this.providersList.others, [details => details.costing.value], [order]));
            this._getDefaultSelectedProvider();
        }

        _sortByTime() {
            let order = this.selectedSortByOption === 3 ? 'asc' : 'desc';
            this.publicRoutes = clone(orderBy(this.publicRoutes, [details => details.route.duration.value], [order]));
        }

        _updateSortByList() {
            let sortBy = this.directionDetails.type === "privateTrip" ? 'byCost' : 'byTime';
            this.sortByList = clone(this.tripPlannerService.getTripPlanningSortByOptions(sortBy));
            this.selectedSortByOption = head(this.sortByList).id;
            this._sortList();
        }

        _updateDirectionDetails() {
            this.directionDetails.departAt = this._getDepartAtDate();
            this.directionDetails.type = this.selectedServiceType.name === "Public Transit" ? "getPublicRoute" : "privateTrip";
            this.directionDetails = clone(this.directionDetails);
            this._hideMapLoaderOnlyIfSelectedServiceTypeIsNotPublic();
            // this.directionDetails.type === "privateTrip" ? this._getPrivateProvidersDetails() : true;
        }

        _hideMapLoaderOnlyIfSelectedServiceTypeIsNotPublic() {
            if (this.selectedServiceType.name !== "Public Transit") {
                this._hideMapLoader();
            }
        }

        _getPrivateProvidersDetails() {
            const serviceTypeName = this.selectedServiceType.name;
            const serviceTypeId = this.selectedServiceType.id;
            const { requirements = "", isVeteran = null, isMedicaid = null, originServiceAreas = "", destinationServiceAreas = "" } = this.advanceOptionsDetails;
            const departAt = this._resetDateWithTime();
            this.tripPlannerService.getPrivateProvidersDetails({
                originServiceAreas,
                destinationServiceAreas,
                isVeteran,
                isMedicaid,
                requirements,
                serviceTypeName,
                serviceTypeId,
                departAt
            })
                .then(({ providers }) => {
                    this._updateProvidersList(providers);
                    this.providersList = this._getSelectedProvidersList();
                    this._getDefaultSelectedProvider();
                    this.addServiceTypeDetailsInGoogleAnalytics('serviceRequestType');
                    this._updateCountyLevelSearchInGoogleAnalytics();
                    this._hideMapLoader();
                })
                .catch(err => {
                    this._noResultFound();
                    this._hideMapLoader();
                });
        }

        _updateProvidersList({ privateProviders, paratransitProviders, volunteerProviders }) {
            this.privateProviders = privateProviders;
            this.paratransitProviders = paratransitProviders;
            this.volunteerProviders = volunteerProviders;
        }

        _visiblePrintSection() {
            this.isPrintSectionVisible = !this.isPrintSectionVisible;
        }

        _getPublicRouteDetailsObject({ route: { steps } }) {
            this.directionDetails.type = "publicRoutes";
            this.directionDetails.steps = this.tripPlannerService.getPublicRoutesStepsObject(steps);
            this.directionDetails.stops = this.tripPlannerService.getPublicRoutesStopsObject(steps);
            this.directionDetails = clone(this.directionDetails);
        }

        _changeDepartOption() {
            this.showDepartOption = !this.showDepartOption;
        }

        _changeDepartFilter(selectedOption) {
            this.departAt = (selectedOption === 'leaveNow') ? false : true;
            !this.departAt ? this._resetDepartAtDateTime() : true;
            this._changeDepartOption();
        }

        _resetDepartAtDateTime() {
            this.selectedDepartTime.range.startTime.selectedTime = new Date();
            this.departDateDetails.selectedDate = new Date();
            this.directionDetails.departAt = this._getDepartAtDate();
            this.selectedServiceType.name === "Public Transit" ? this._updateDirectionDetails() : this._getPrivateProvidersDetails();
        }

        _getClass(day) {
            return this.viewSelectedProviderDetails && day ? this.viewSelectedProviderDetails.daysOfOperation[day] === true ? 'activeDay' : 'inActiveDay' : '';
        }

        _hideProviderDetails() {
            this.viewDetails = false;
        }

        _viewRouteDetails() {
            this.viewDetails = true;
        }

        _getClassForSchedule(details, day) {
            return details && day ? details.daysOfOperation[day] === true ? 'activeDay' : 'inActiveDay' : '';
        }

        _viewDetails(id) {
            this.viewSelectedProviderDetails = head(filter(this.providersList.filtered, provider => id === provider.id));
            this.viewSelectedProviderDetails = !this.viewSelectedProviderDetails ? head(filter(this.providersList.others, provider => id === provider.id)) : this.viewSelectedProviderDetails;
            this.viewDetails = true;
        }

        _resetAllFlags() {
            this.viewDetails = false;
            this.changeSearch = false;
            //this.departAt = false;
            //this.showDepartOption = false;
            this.mobileSearchOption = false;
            this.mobileFilterOption = false;
            this.mobileDepartOption = false;
            this.mobileMapViewOption = false;
            this.isPrintOptionsVisible = false;
            this.isPrintSectionVisible = false;
            this.isPrintWithMap = true;
            this.mobileHelpViewOption =false;
        }

        _setPublicProviderRouteDetails(routesDetailsObject) {
            if (routesDetailsObject && !isEmpty(routesDetailsObject)) {
                this.noResultFound = false;
                return this.tripPlannerService.getPublicProviderDetailsAndMapWithRoutes(routesDetailsObject.routes)
                    .then(routes => {
                        this._hideMapLoader();
                        this.publicRoutes = angular.copy(routes);
                        // make the first item in the list as selected
                        if (this.publicRoutes.length > 0) {
                            this.publicRoutes[0].isSelected = true;
                            this.selectedPublicRoute = head(this.publicRoutes);
                            this._getPublicRouteDetailsObject(this.selectedPublicRoute);
                        } else {
                            this._noResultFound();
                            this._hideMapLoader();
                        }
                        return Promise.resolve(true);
                    });
            }
            return Promise.resolve(false);
        }

        _getBreakJourneyRoutesIfPublicRoutesNotAvailable(isPublicRouteAvailable) {
            if (!isPublicRouteAvailable) {
                const { origin: { latlng: originLatLng }, destination: { latlng: destinationLatLng }, departAt } = this.directionDetails;
                const privateRouteConfig = {
                    origin: originLatLng,
                    destination: destinationLatLng,
                    travelMode: google.maps.TravelMode['DRIVING']
                };
                return this.googleMapService.getRoute(privateRouteConfig, this.googleMapRouteDelayInMiliSeconds, true)
                    .then(result => this._setRadiusAndMaxDistanceFromRoutesDetails(result))
                    .then(_ => this._getRouteDetailsForOrigin(originLatLng, destinationLatLng, departAt))
                    .then(routeDetails => routeDetails.length > 0 ? routeDetails : this._getRouteDetailsForDestination(destinationLatLng, departAt))
                    .then(routeDetails => {
                        if (routeDetails.length > 0) {
                            this._drawRoutesForBreakJourney(routeDetails)
                        } else {
                            this.$timeout(() => {
                                this.noResultFound = true;
                            });
                        }
                    });
            }
        }

        _setRadiusAndMaxDistanceFromRoutesDetails(details) {
            const { routes: [{ legs: [{ distance: { value } }] }] } = details;
            this.radius = this._getRadius(value);
            this.maxDistance = this._getMaxDistance(value);
        }

        _executeRequestInChunks(busStops, requestFn, chunkValue = 5) {
            return Promise.all(map(busStops, (stop, ({ geometry: { location: { lat, lng } } }, index) => {
                return new Promise((resolve, reject) => {
                    this.$timeout(_ => {
                        const latLngDetails = { lat: lat(), lng: lng() };
                        const publicRouteConfig = requestFn(latLngDetails);
                        return this.googleMapService.getRoute(publicRouteConfig, this.googleMapRouteDelayInMiliSeconds, true)
                            .then(routes => resolve(routes));
                    }, 700 * index);
                });
            })));
        }

        _getRouteDetailsForOrigin(origin, destination, departAt) {
            return this._getNearByBusStation(origin)
                .then(results => this.originBusStationDetails = results)
                .then(_ => this._executeRequestInChunks(this.originBusStationDetails, (latLngDetails) => {
                    return this._getPublicRouteConfig(latLngDetails, destination, departAt);
                }))
                .then(routes => routes);
        }

        _getRouteDetailsForDestination(location, departAt) {
            return this._getNearByBusStation(location)
                .then(results => this.destinationBusStationDetails = results)
                .then(_ => {
                    const routes = [];
                    map(this.destinationBusStationDetails, (val, index) => {
                        const delay = (index + 1) * this.googleMapRouteDelayInMiliSeconds * 2;
                        this.$timeout(() => {
                            const destinationLatLngDetails = {
                                lat: val.geometry.location.lat(),
                                lng: val.geometry.location.lng()
                            };
                            map(this.originBusStationDetails, (originVal) => {
                                const originLatLngDetails = {
                                    lat: originVal.geometry.location.lat(),
                                    lng: originVal.geometry.location.lng()
                                };
                                const publicRouteConfig = this._getPublicRouteConfig(originLatLngDetails, destinationLatLngDetails, departAt);
                                routes.push(this.googleMapService.getRoute(publicRouteConfig, this.googleMapRouteDelayInMiliSeconds, true));
                            });
                        }, delay);
                    });

                    return Promise.all(routes).then(result => reduce(result, (arr, val) => {
                        if (val && val.status === 'OK') {
                            arr.push(val);
                        }
                        return arr;
                    }, []));
                });
        }

        _getChunkOfBusStops(busStops) {
            return chunk(busStops, 3);
        }

        _getNearByBusStation(location) {
            return this.googleMapService.getNearbyPlace(this.mapElement, location, this.radius);
        }

        _drawRoutesForBreakJourney(routesDetails) {
            if (routesDetails && routesDetails.length > 0) {
                this.noResultFound = false;
                return this.tripPlannerService.getPublicProviderDetailsWithRoutes(routesDetails)
                    .then(details => {
                        this._getPrivateBreakJourneyDetails(details).then(result => {
                            this.$timeout(() => {
                                this.publicRoutes = reduce(result, (arr, val, index) => {
                                    // console.log(val.route.distance.value);
                                    // if (val.route.distance.value <= this.maxDistance) {
                                    val.id = index;
                                    val.isSelected = false;

                                    const timeValue = this._getRouteTotalTime(val.route.steps);
                                    const timeText = this.dateService.convertSecondsToHoursAndMinute(timeValue);
                                    val.route.duration = { value: timeValue, text: timeText };
                                    const distanceValue = this._getRouteTotalDistance(val.route.steps);
                                    const distanceText = this._convertMeterToMiles(distanceValue);
                                    val.route.distance = { value: distanceValue, text: `${distanceText} mi` };
                                    arr.push(val);
                                    // }
                                    return arr;
                                }, []);
                                this.publicRoutes = sortBy(this.publicRoutes, ['route.duration.value']);
                                if (size(this.publicRoutes) > 0) {
                                    this.publicRoutes[0].isSelected = true;
                                    this.noResultFound = false;
                                    this.selectedPublicRoute = head(filter(this.publicRoutes, route => route.isSelected)) || head(this.publicRoutes);
                                    this._getPublicRouteDetailsObject(this.selectedPublicRoute);
                                } else {
                                    this.noResultFound = true;
                                }
                            });
                        });
                    }).catch(err => {
                        this.noResultFound = true;
                    });
            }
            return Promise.resolve(false);
        }

        _getPrivateBreakJourneyDetails(routesDetails) {
            const { origin: { latlng: originLatLng }, destination: { latlng: destinationLatLng } } = this.directionDetails;
            const promise = map(routesDetails, (val) => {
                const selectedPublicRoute = head(filter(val.routes, route => route.isSelected));
                const { route: { steps: [{ startLocation: originLatLngDetailsForDestination }] } } = selectedPublicRoute;
                return this._getPrivateRoutesForBreakJourney(originLatLng, originLatLngDetailsForDestination)
                    .then(originStepsDetails => {
                        if (originStepsDetails) {
                            val.routes = map(val.routes, (val) => {
                                val.route.steps.unshift(...originStepsDetails);
                                return val;
                            });
                        } else {
                            val.routes = [];
                        }
                    })
                    .then(_ => {
                        if (this.destinationBusStationDetails.length > 0) {
                            const { route: { steps } } = selectedPublicRoute;
                            const { endLocation: destinationLatLngDetailsForOrigin } = last(steps);
                            return this._getPrivateRoutesForBreakJourney(destinationLatLngDetailsForOrigin, destinationLatLng);
                        }
                        return false;
                    })
                    .then(destinationStepsDetails => {
                        if (destinationStepsDetails && destinationStepsDetails.length > 0) {
                            val.routes = map(val.routes, (val) => {
                                val.route.steps.push(...destinationStepsDetails);
                                return val;
                            });
                        } else if (val.routes.length > 0 && this.destinationBusStationDetails.length > 0) {
                            val.routes = [];
                        }
                    })
                    .then(_ => {
                        if (val.routes.length > 0) {
                            return val;
                        }
                    });
            });
            return Promise.all(promise).then(result => {
                return reduce(compact(result), (arr, { routes }) => {
                    if (routes && routes.length > 0) {
                        arr = arr.concat(routes);
                    }
                    return arr;
                }, []);
            });
        }

        _getPrivateRoutesForBreakJourney(origin, destination) {
            const privateRouteConfig = {
                origin,
                destination,
                travelMode: google.maps.TravelMode['DRIVING']
            };

            return this.googleMapService.getRoute(privateRouteConfig, this.googleMapRouteDelayInMiliSeconds, true).then(result => {
                if (result) {
                    const { routes: [{ legs: [{ steps }] }] } = result;
                    const { travel_mode: travelMode, lat_lngs: latlngs, end_location: endLocation, instructions } = last(steps);
                    const formattedSteps = map(steps, (val) => {
                        val.travelMode = val.travel_mode;
                        val.latlngs = val.lat_lngs;
                        return val;
                    });
                    formattedSteps[findLastIndex(formattedSteps)].endLocation = {
                        lat: endLocation.lat(),
                        lng: endLocation.lng()
                    };
                    formattedSteps[findLastIndex(formattedSteps)].instructions = instructions;
                    return formattedSteps;
                }
                return null;
            });
        }

        _getRadius(distanceInMeters, maxRadiusInMeters = 16093 /* 5 miles */) {
            const radiusInMeters = (distanceInMeters / 2);
            return radiusInMeters > maxRadiusInMeters ? maxRadiusInMeters : radiusInMeters;
        }

        _getMaxDistance(distance) {
            const percent = 90;
            return Math.round(distance + (distance * (percent / 100)));
        }

        _getRouteTotalTime(steps) {
            return sumBy(steps, 'duration.value');
        }

        _getRouteTotalDistance(steps) {
            return sumBy(steps, ({ distance }) => {
                if (typeof distance === 'string') {
                    const [val, type] = distance.split(' ');
                    if (type === 'ft') {
                        return this._convertFtToMeter(val);
                    }

                    if (type === 'mi') {
                        return this._convertMilesToMeter(val);
                    }
                }
                if (typeof distance === 'object') {
                    return distance.value;
                }
            });
        }

        _convertFtToMeter(val) {
            const feetConstant = 0.3048;
            return Math.round(val * feetConstant);
        }

        _convertMilesToMeter(val) {
            const mileConstant = 1609.344;
            return Math.round(val * mileConstant);
        }

        _convertMeterToMiles(val) {
            const mileConstant = 1609.344;
            return Math.round(val / mileConstant);
        }

        _getPublicRouteConfig(origin, destination, departAt) {
            return {
                origin,
                destination,
                travelMode: 'TRANSIT',
                transitOptions: {
                    modes: ['BUS'],
                    departureTime: departAt
                },
                provideRouteAlternatives: true
            };
        }

        _isSearchCountyRegisteredInGoogleAnalytics() {
            const index = this.Constants.COUNTY_TO_TRACK_FOR_ANALYTICS.indexOf(this.countyName);
            return index !== -1;
        }

        _getCountyName() {
            return last(JSON.parse(this.advanceOptionsDetails.originServiceAreas)).placeShortName;
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner-main/trip-planner-main.component.js